import { BoxInfo, MnemoLoading, Title } from "components/misc";
import { ROUTES } from "const";
import { Button, Card, CardBody, Icon } from "design-react-kit";
import { lessonLiveService, networkErrorHelper } from "libs";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

class CourseLessonLiveMaterials extends Component {
  state = {
    loading: true,
    loadingError: false,
    lessonLiveMaterialFiles: [],
    rCode: "",
    idClass: "",
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;

    this.setState({
      rCode,
    });

    this.loadRemote(rCode);
  }

  loadRemote(rCode) {
    this.setState({ loading: true, loadingError: false });

    lessonLiveService
      .myLessonMaterials(rCode)
      .then(({ data }) => {
        const { lessonLiveMaterialFiles } = data.payload;

        this.setState({
          lessonLiveMaterialFiles,
          loading: false,
        });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }

        this.setState({ loadingError: true, loading: false });
      });
  }

  openUrl(url) {
    window.open(url, "_blank");
  }

  downloadFile(file) {
    window.open(file.location, "_blank");
  }

  render() {
    const { loading, lessonLiveMaterialFiles, rCode } = this.state;

    if (loading) return <MnemoLoading />;

    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right"
        >
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Materiale Didattico</Title>
        <Card
          noWrapper={false}
          tag="div"
          className="card-bg card-big rounded shadow border-bottom-card mb-5"
        >
          <div className="flag-icon" />
          <div className="etichetta">
            <span>MATERIALE DIDATTICO</span>
          </div>
          <CardBody tag="div">
            {lessonLiveMaterialFiles && lessonLiveMaterialFiles.length > 0 ? (
              lessonLiveMaterialFiles.map((folder, index) => (
                <div key={`folder-${folder.folderName}`} className="mb-4">
                  {folder.folderName && (
                    <h3 className="mb-3">{folder.folderName}</h3>
                  )}
                  {folder.materials.map((material) => (
                    <div key={`material-${material.id}`} className="mb-3">
                      {material.type === "file" ? (
                        material.files.map((file) => (
                          <BoxInfo
                            className="my-0 mnemo-dopzone-boxInfo d-flex justify-content-between align-items-center"
                            key={`file-${file.id}`}
                          >
                            <div className="me-3">
                              <strong>{material.title}</strong>
                              {material.description && (
                                <p className="mb-0">{material.description}</p>
                              )}
                            </div>
                            <Button
                              className="mx-1"
                              color="primary bg-dark"
                              size="xs"
                              onClick={() => this.downloadFile(file)}
                            >
                              Scarica
                            </Button>
                          </BoxInfo>
                        ))
                      ) : (
                        <BoxInfo className="my-0 mnemo-dopzone-boxInfo d-flex justify-content-between align-items-center">
                          <div className="me-3">
                            <strong>{material.title}</strong>
                            {material.description && (
                              <p className="mb-0">{material.description}</p>
                            )}
                          </div>
                          <Button
                            className="mx-1"
                            color="primary bg-dark"
                            size="xs"
                            onClick={() => this.openUrl(material.url)}
                          >
                            Apri
                          </Button>
                        </BoxInfo>
                      )}
                    </div>
                  ))}

                  {index < lessonLiveMaterialFiles.length - 1 && (
                    <hr className="my-4" />
                  )}
                </div>
              ))
            ) : (
              <p>Nessun materiale didattico caricato</p>
            )}
          </CardBody>
        </Card>
      </>
    );
  }
}

export default withRouter(CourseLessonLiveMaterials);
